/** 生产环境公网域名（开发环境仍用 localhost:9088/9089） */
export const TENANT_PORTAL_URL = 'https://cloud.gridorbit.cn';
export const ADMIN_PORTAL_URL = 'https://mg.gridorbit.cn';
export const WWW_SITE_URL = 'https://www.gridorbit.cn';
export const ICP_BEIAN_NO = '粤ICP备2026129440号-1';
export const ICP_BEIAN_URL = 'https://beian.miit.gov.cn/';
